import { connect } from 'react-redux'

import List from './units'

const mapStateToProps = state => ({
  data: state.RunProject.data,
  isLoading: state.RunProject.isLoading,
})

const mapDispatchToProps = () => ({
  handleDetail(id) {
    return id
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List)
